module.exports = __webpack_public_path__ + "media/41.83b5b8c8.mp3";